import { BrokerDetail } from '@insurance/api/requests'
import { DownloadButton } from '@insurance/components'
import { Text } from '@shared/components'
import { validatePdfFile } from '@shared/utils'
import { Button, Flex, Form, Space } from 'antd'
import Dragger from 'antd/es/upload/Dragger'
import { DocumentUpload, Trash } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = { company?: BrokerDetail }

export const CompaniesContractField = ({ company }: Props) => {
  const { t } = useTranslation()
  const formInstance = Form.useFormInstance()
  const canUpload = Form.useWatch('__can_upload', { preserve: true })

  const onRemove = () => {
    formInstance.setFieldValue('__can_upload', true)
    formInstance.setFieldValue('contract', null)
  }

  return (
    <Form.Item
      name="contract"
      label={t('contract_file')}
      rules={[
        {
          validator: (_, value) => validatePdfFile(value, t)
        }
      ]}
    >
      {!company?.contract || canUpload ? (
        <Dragger
          maxCount={1}
          accept=".pdf"
          onRemove={onRemove}
          customRequest={({ onSuccess }) => onSuccess?.({})}
        >
          <Flex vertical gap={10}>
            <Flex justify="center" align="center" gap={10}>
              <DocumentUpload size={20} />

              <Text>{t('upload_contract')}</Text>
            </Flex>

            <Text>{t('upload_contract_text')}</Text>
          </Flex>
        </Dragger>
      ) : (
        <Space.Compact block>
          <DownloadButton
            color="primary"
            variant="outlined"
            block
            file={company?.contract}
          />
          <Button
            type="primary"
            icon={<Trash size={16} />}
            onClick={onRemove}
          />
        </Space.Compact>
      )}
    </Form.Item>
  )
}
